/* RESPONSIBLE TEAM: team-fin-nux */
/* eslint-disable ember/no-controllers */
import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class FinStudioController extends Controller {
  queryParams = ['fin_success_experiment'];
  @tracked fin_success_experiment: string | null = null;
}
